// ListingCard.jsx
import React from "react";
import { Card, ListGroup } from "react-bootstrap";
import carImage from "../../../assets/default-image.png";
import { useGetProductListingQuery } from "../../../rtk-query/slices/product/productListingSlice";
import {
  ShimmerContentBlock,
  ShimmerSectionHeader,
} from "react-shimmer-effects";
import icon from "../../../assets/no-book-icon.png";

const HomeListingCard = ({ dashboardListings }) => {
  const { data: productList, isLoading } = useGetProductListingQuery({
    limit: 100,
    page: 1,
  });

  return (
    <Card className="dod-dash-main-page-listing-card">
      <Card.Body>
        <h4>Latest Listings</h4>
        <ListGroup variant="flush">
          {isLoading ? (
            <ShimmerSectionHeader />
          ) : (
            dashboardListings?.products?.latestProducts?.map(
              (productData, index) => (
                <ListGroup.Item
                  key={index}
                  className="dod-dash-main-page-listing-item"
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={
                        productData?.product_cover_image
                          ? productData?.product_cover_image
                              ?.product_image_filename
                          : carImage
                      }
                      alt={productData?.product_title}
                      className="dod-dash-main-page-listing-img"
                    />
                    <div>
                      <h6 className="m-0 p-0 home-list-text-title">
                        {productData?.product_lang?.product_title}
                      </h6>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: productData?.product_lang?.product_overview,
                        }}
                        className="m-0 p-0 home-list-text-overview"
                      ></p>
                    </div>
                  </div>
                </ListGroup.Item>
              )
            )
          )}
        </ListGroup>
        {dashboardListings?.products?.latestProducts?.length === 0 && (
          <div className="d-flex align-items-center justify-content-center bg-white rounded-md my-5 py-3">
            <div className="my-2 py-5">
              <div className="d-flex align-items-center justify-content-center"></div>
              <img className="mb-3 no-booking-img" src={icon} alt="empty" />
              <p className="m-0 cp-label text-center">
                No latest listing avaliable!
              </p>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default HomeListingCard;
